export const getCurrentProjectById = (projects, currentProjectId) => projects.find(project => project.id === currentProjectId)